import React from 'react';
import { Redirect } from 'react-router-dom';
import usePermisos from 'src/hooks/usePermisos';
import LoadingScreen from 'src/components/LoadingScreen';

function RutaProtegida({ permiso, children }) {
  const { puede, cargando } = usePermisos();

  if (cargando) return <LoadingScreen />;

  if (!puede(permiso)) return <Redirect to="/sin-permisos" />;

  return children;
}

export default RutaProtegida;
